(function($){
    $(function() {
       /////////////////////
       var init = function(){
           var $builder = $('#product-builder');
           var updatePrice = function() {
               setTimeout( function() {
                    if((! window.CPB) && (! window.CPB.getStore)) return;
                    var price = window.CPB.getStore().getState().Product.price;
                    $builder.find('.cpb-product-actions .cpb-money').text(window.Shopify.formatMoney(price * 100,'CA${{amount}}'));
                }, 10);
           };
           $builder.on('click', '.cpb-option-type-img img', updatePrice);
           $builder.on('click', '.cpb-option-type-text', updatePrice); 
           $builder.on('click', '.cpb-reset-button', updatePrice);
           $builder.on('click', '.cpb-option-type-color', updatePrice);
         
       };
        
        var cpbLoaded = function() {
            if ($('.cpb-add-to-cart-button').length > 0) {
                init();
                //cpb-quantity-value
                //cpb-product-actions
                
            } else {
              window.requestAnimationFrame(cpbLoaded);
            }   
        };
        cpbLoaded(); 
        
    });    
})(jQuery);